import { Page, View, Text, Image } from '@react-pdf/renderer';
import { StyleSheet } from '@react-pdf/renderer';
import { LaudoHeader, QuestionarioItem, Footer } from '../../../types';
import { AVMPageFooter } from '../AVM/components';
import { usePhotoFilter, FotoIndividual } from '../../hooks/usePhotoFilter';

const s = StyleSheet.create({
  page: { width: 595, height: 842, backgroundColor: '#FFFFFF', flexDirection: 'column', fontFamily: 'Helvetica', paddingBottom: 40 },
  headerBar: { paddingBottom: 8, borderBottom: '1 solid #D6DBE7', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  sectionHeader: { flexDirection: 'row', alignItems: 'center', backgroundColor: '#F5F6F9', gap: 8, paddingRight: 8 },
  accentBlue: { width: 3, height: 28, backgroundColor: '#0090FF' },
  title: { color: '#000000', fontSize: 9, fontWeight: 'bold' },
});

interface RelatorioFotograficoProps {
  header: LaudoHeader;
  questionario: QuestionarioItem[];
  footer: Footer;
  logoBase64?: string;
  photoOrder?: string[];
}

function PhotoCard({ foto, index }: { foto: FotoIndividual; index: number }) {
  const hasUrl = foto.photo.fileUrl && foto.photo.fileUrl.length > 10;

  return (
    <View style={{ width: '48%', overflow: 'hidden', marginBottom: 8 }}>
      {/* Dark header */}
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#001F3F', paddingHorizontal: 4, paddingVertical: 3 }}>
        <Text style={{ color: '#FFFFFF', fontSize: 6, fontWeight: 'bold' }}>Foto {index + 1} - {foto.pergunta}</Text>
        <Text style={{ color: '#FFFFFF', fontSize: 6 }}>Data/hora · GPS</Text>
      </View>

      {/* Image */}
      <View style={{ width: '100%', height: 140, backgroundColor: '#F5F6F9', justifyContent: 'center', alignItems: 'center' }}>
        {hasUrl ? (
          <Image src={foto.photo.fileUrl} style={{ width: '100%', height: 140, objectFit: 'contain' }} />
        ) : (
          <Text style={{ fontSize: 8, color: '#000000' }}>[ Foto ]</Text>
        )}
      </View>

      {/* Caption */}
      <View style={{ paddingHorizontal: 4, paddingVertical: 3, borderTop: '1 solid #D6DBE7' }}>
        <Text style={{ fontSize: 7, color: '#000000' }}>
          {foto.photo.caption || `${foto.pergunta}`}
        </Text>
      </View>
    </View>
  );
}

export function RelatorioFotografico({
  header,
  questionario,
  footer,
  logoBase64,
  photoOrder,
}: RelatorioFotograficoProps) {
  const { fotosOrdenadas, temFotos } = usePhotoFilter(questionario, photoOrder);

  if (!temFotos) return null;

  return (
    <Page size="A4" style={s.page}>
      {/* Fixed header */}
      <View fixed style={{ paddingHorizontal: 16, paddingTop: 16 }}>
        <View style={s.headerBar}>
          {logoBase64 ? (
            <Image src={logoBase64} style={{ width: 64, height: 24, objectFit: 'contain' }} />
          ) : (
            <Text style={{ fontSize: 16, fontWeight: 'bold', color: '#101010' }}>bari.</Text>
          )}
          <View style={{ flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
            <Text style={{ textAlign: 'right', color: '#000000', fontSize: 10, fontWeight: 'bold' }}>LAUDO DE AVALIAÇÃO</Text>
            <Text style={{ textAlign: 'right', color: '#000000', fontSize: 9 }}>{header.idLaudo}  ·  {header.formatoLaudo}</Text>
          </View>
        </View>
        <View style={[s.sectionHeader, { marginTop: 12 }]}>
          <View style={s.accentBlue} />
          <Text style={s.title}>RELATÓRIO FOTOGRÁFICO</Text>
        </View>
      </View>

      {/* Photo grid: 2 per row, 3 rows per page = 6 photos */}
      <View style={{ paddingHorizontal: 16, paddingTop: 8, flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
        {fotosOrdenadas.map((foto, idx) => (
          <PhotoCard key={idx} foto={foto} index={idx} />
        ))}
      </View>

      <AVMPageFooter footer={footer} />
    </Page>
  );
}
